export function BlogHeader({ children }: { children: React.ReactNode }) {
  return (
    <header className="flex flex-row content-center justify-between gap-5 w-full relative">
      {children}
    </header>
  );
}
